import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BaseService, DataBaseServiceResponse} from '../../services/base-service/base.service';
import {IRecordHistoryAttitude} from './record-history-attitude.interface';

export interface IRRecordHistoryAttitude {
  recordHistoryAttitude: IRecordHistoryAttitude;
  wasDeployed?: boolean;
}

export namespace RecordHistoryAttitudeAction {
  export class GetActive {
    static readonly type = '[Record] Get Record History Attitude Action';
    constructor(public serviceId: string, public patientId: string) { }
  }

  export class PatchActive {
    static readonly type = '[Record] Patch Record History Attitude  Action';
    constructor(public serviceId: string, public patientId: string, public environmentAffectivity: IRecordHistoryAttitude) { }
  }

  export class Deploy {
    static readonly type = '[Record] Was Deployed History Attitude Action';
    constructor(public value: boolean) { }
  }
}


@State<IRRecordHistoryAttitude>({
  name: 'RecordHistoryAttitudeState',
  defaults: {
    recordHistoryAttitude: null
  },
})

@Injectable()
export class RecordHistoryAttitudeState {
  constructor(
    private baseService: BaseService<any>,
  ) {
  }
  url = environment.SERVER_URL;

  @Selector()
  public static getRecordHistoryAttitude(state: IRRecordHistoryAttitude): IRecordHistoryAttitude {
    return state.recordHistoryAttitude;
  }

  @Selector()
  public static getWasDeployed(state: IRRecordHistoryAttitude): boolean {
    return state.wasDeployed;
  }

  @Action(RecordHistoryAttitudeAction.GetActive)
  async getRecordHistoryAttitudeAction(ctx: StateContext<IRRecordHistoryAttitude>, action: RecordHistoryAttitudeAction.GetActive): Promise<void> {
    const response: DataBaseServiceResponse<IRecordHistoryAttitude> = await firstValueFrom(
      this.baseService.get(`${this.url}/patients/${action.patientId}/service/${action.serviceId}/records/attitude/active`)
    );

    if (response.error) throw new Error(response.message);

    ctx.patchState({
      recordHistoryAttitude: response.entity
    });
  }
  @Action(RecordHistoryAttitudeAction.PatchActive)
  async patchRecordHistoryAttitudeAction(
    ctx: StateContext<IRRecordHistoryAttitude>,
    action: RecordHistoryAttitudeAction.PatchActive
  ): Promise<void> {
    const response: DataBaseServiceResponse<void> = await firstValueFrom(
      this.baseService.patch(
        `${this.url}/patients/${action.patientId}/service/${action.serviceId}/records/attitude`,
        action.environmentAffectivity
      )
    );

    if (response.error) throw new Error(response.message);
  }

  @Action(RecordHistoryAttitudeAction.Deploy)
  async wasDeployedRecordHistoryAttitudeAction(
    ctx: StateContext<IRRecordHistoryAttitude>,
    action: RecordHistoryAttitudeAction.Deploy
  ): Promise<void> {
    ctx.patchState({
      wasDeployed: action.value
    });
  }

}
